import {
  View,
  Text,
  StyleSheet,
  Image,
  TouchableOpacity,
  Platform,
  BackHandler,
  Keyboard,
  ScrollView,
  Pressable,
} from "react-native";
import React, { useEffect, useRef, useState } from "react";
import { AppColors } from "../../../utility/AppColors";
import CommonShadow from "../../../common/CommonShadow";
import { AppImages } from "../../../utility/AppImages";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import {
  DrawerActions,
  StackActions,
  useNavigation,
} from "@react-navigation/native";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { s } from "react-native-size-matters";
import { ActivityIndicator } from "react-native";
import { getLoginData, removeLoginData } from "../../../utility/AppStoreData";
import { toast } from "react-toastify";
import { base_url, endpoints, genres } from "../../../Api/configs";
import CommonTextInputWeb from "../../../common/CommonTextInputWeb";
import { CommonButton, CommonSearchButton } from "../../../common/CommonButton";
import { FlatList } from "react-native";
import { ShowLoader } from "../../../common/ShowLoader";
import { SearchScreentNavigationHeader } from "./Common/MobileDeviceNavigationHeader";
import { screenWidth } from "../../../utility/Index";
import HomeItem from "./Common/HomeItem";
import SearchResult from "../../../Components/search-common-components/SearchResult";
import UserListing from "../../../Components/search-common-components/UserListing";
import GameGenre from "../../../Components/Genre";
import SearchModalChallenges from "../../../Components/search-common-components/SearhedData";
import SearhedData from "../../../Components/search-common-components/SearhedData";
import Genre from "../../../Components/Genre";
import Separator from "../../../Components/Separator";
import SearchGameComponent from "../../../Components/search-common-components/SearchGameComponent";
import HomeCards from "../../../Components/home-common-components/HomeCards";
import BuyTicketModal from "./Modals/BuyTicketModal";
import { getUserProfile } from "../../../services/authAPI";
import SearchPageSkeleton from "../../../Components/skeleton-components/SearchPageSkeleton";
import SearchResultSkeleton from "../../../Components/skeleton-components/SearchResultSkeleton";
import UserListingSkeleton from "../../../Components/skeleton-components/UserListingSkeleton";
import GenreSkeleton from "../../../Components/skeleton-components/GenreSkeleton";
import Cards from "../../../Components/Cards";
import Header from "./Common/Header";
import { AppScreens } from "../../Utility/AppScreens";
import { ScreenBGGradientView } from "../../../common/CommonView";

const SearchEventWebScreen = ({ route }) => {
  const routeData = route.params;
  const navigation = useNavigation();
  const styles = useStyles();
  const deviceSize = useDeviceSize();

  const [showLoader, setShowLoader] = useState(false);
  const [searchEvent, setSearchEvent] = useState("");

  const [numberOfColoums, setNumberOfColoums] = useState(4);

  const [userData, setUserData] = useState(null);
  const [originalChallengeResult, setOriginalChallengeResult] = useState([]);
  const [originalTournamentResult, setOriginalTournamentResult] = useState([]);
  const [challengeResult, setChallengeResult] = useState([]);

  const [tournamentResult, setTournamentResult] = useState([]);
  const [gameResult, setGameResult] = useState([]);
  const [gameResultEmpty, setGameResultEmpty] = useState(false);
  const [challengeResultEmpty, setChallengeResultEmpty] = useState(false);
  const [tournamentResultEmpty, setTournamentResultEmpty] = useState(false);
  const [userResult, setUserResult] = useState([]);
  const [userResultEmpty, setuserResultEmpty] = useState(false);
  const [arrPopularGeners, arrSetPopularGeners] = useState(genres);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [accessToken, setAccessToken] = useState("");
  const [isGetTicket, setIsGetTicket] = useState(false);
  const [popularIndex, setPopularIndex] = useState(0);
  const [userProfileData, setUserProfileData] = useState(null);
  useEffect(() => {
    if (routeData != null && routeData.txtSearch) {
      let txtSearch = routeData.txtSearch;
      setSearchEvent(txtSearch);
      callSearchAPI(txtSearch);
    }
    getLoginUserData();
  }, []);

  const userProfileAPI = async (AccessToken?: string) => {
    try {
      const data = await getUserProfile(AccessToken);
      const responseBody =
        typeof data.body === "string" ? JSON.parse(data.body) : data.body;

      if (data.statusCode === 200) {
        setUserProfileData(responseBody);
      } else if (data.statusCode == 400) {
        toast.error("Bad Request");
      } else if (data.statusCode > 400 && data.statusCode < 420) {
        toast.error("Unauthorized");
      } else if (data.statusCode >= 500) {
        toast.error("Internal Server Error");
      }
    } catch (error) {
      console.log("Authorization failed: " + error.message);
      toast.error(error.message);
    }
  };
  const callSearchAPI = (txtSearch) => {
    searchEventAPI({
      txtSearch: txtSearch,
      success: (response) => {
        if (response) {
          response.usersResult.length === 0
            ? setuserResultEmpty(true)
            : setuserResultEmpty(false);

          setUserResult(response.usersResult);
          if (
            response.challengeResult &&
            Array.isArray(response.challengeResult)
          ) {
            response.challengeResult.length > 0
              ? setChallengeResultEmpty(false)
              : setChallengeResultEmpty(true);
            setOriginalChallengeResult(response.challengeResult);
            setChallengeResult(response.challengeResult);
          }
          if (
            response.tournamentResult &&
            Array.isArray(response.tournamentResult)
          ) {
            response.tournamentResult.length > 0
              ? setTournamentResultEmpty(false)
              : setTournamentResultEmpty(true);
            response.gamesResult.length > 0
              ? setGameResultEmpty(false)
              : setGameResultEmpty(true);
            setOriginalTournamentResult(response.tournamentResult);
            setTournamentResult(response.tournamentResult);
            setGameResult(response.gamesResult);
          }
        }
      },
    });
  };

  const formatDate = (dateString) => {
    const today = new Date();
    const inputDate = new Date(dateString);

    // Check if the date is today
    if (
      inputDate.getDate() === today.getDate() &&
      inputDate.getMonth() === today.getMonth() &&
      inputDate.getFullYear() === today.getFullYear()
    ) {
      const options = {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      };
      return `Today ${inputDate.toLocaleTimeString(undefined, options)}`;
    }

    // Check if the date is tomorrow
    const tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 1);

    if (
      inputDate.getDate() === tomorrow.getDate() &&
      inputDate.getMonth() === tomorrow.getMonth() &&
      inputDate.getFullYear() === tomorrow.getFullYear()
    ) {
      const options = {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      };
      return `Tomorrow ${inputDate.toLocaleTimeString(undefined, options)}`;
    }

    const dateTimeOptions = {
      day: "2-digit",
      month: "short",
      year: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };

    return inputDate.toLocaleDateString(undefined, dateTimeOptions);
  };
  const filterEventsByTag = (tag: string, id: number) => {
    const updatedGenres = arrPopularGeners.map((genre) =>
      genre.id === id
        ? { ...genre, isSelected: 1 }
        : { ...genre, isSelected: 0 }
    );
    arrSetPopularGeners(updatedGenres);

    const filteredChallengeData = originalChallengeResult.filter((event) =>
      event.gameTags.includes(tag)
    );

    setChallengeResult(filteredChallengeData);

    const filteredTournamentResult = originalTournamentResult.filter((event) =>
      event.gameTags.includes(tag)
    );
    setTournamentResult(filteredTournamentResult);
  };
  const handleSearch = () => {
    if (searchEvent.length > 0) {
      callSearchAPI(searchEvent);
    }
  };
  const renderSection = () => {
    const sections = [];

    if (selectedCategory === "All" || selectedCategory === "Users") {
      sections.push(
        <>
          {showLoader ? (
            <UserListingSkeleton size={10} />
          ) : (
            <UserListing
              title="Users"
              userResult={userResult}
              userData={userData}
              userResultEmpty={userResultEmpty}
            />
          )}

          {/* Separater */}
          <View
            style={{
              height: 2,
              backgroundColor: AppColors.appGrayColor_1C1C1C,
              width: "96%",
            }}
          />
        </>
      );
    }
    // if (selectedCategory === "All" || selectedCategory === "genre") {
    //   sections.push(
    //     <>
    //       <Separator
    //         color={AppColors.appGrayColor_1C1C1C}
    //         height={2}
    //         marginTop={0}
    //         marginBottom={0}
    //         width="96%"
    //       />
    //       {showLoader ? (
    //         <GenreSkeleton />
    //       ) : (
    //         <Genre
    //           heading={"Game Genre"}
    //           filterEventsByTag={filterEventsByTag}
    //           arrPopularGeners={arrPopularGeners}
    //         />
    //       )}
    //     </>
    //   );
    // }
    return sections;
  };
  const renderEventSection = () => {
    const sections = [];
    if (
      selectedCategory === "All" ||
      selectedCategory === "Challenge" ||
      selectedCategory === "genre"
    ) {
      sections.push(
        <>
          <Cards
            userData={userData}
            heading="Challenges"
            CardData={challengeResult}
            CardDataEmpty={challengeResultEmpty}
            // setIsGetTicket={setIsGetTicket}
            accessToken={accessToken}
            showLoader={showLoader}
            popularIndex={popularIndex}
            setPopularIndex={setPopularIndex}
            userProfileData={userProfileData}
          />
          <View
            style={{
              height: 2,
              backgroundColor: AppColors.appGrayColor_1C1C1C,
              width: "96%",
            }}
          />
        </>
      );
    }
    // if (selectedCategory === "All" || selectedCategory === "tournament" || selectedCategory === "genre") {
    //   sections.push(
    //     <>
    //       <SearhedData
    //         heading={"Tournament"}
    //         eventsResultEmpty={tournamentResult.length === 0}
    //         eventsResult={tournamentResult}
    //       />
    //     </>
    //   );
    // }
    if (selectedCategory === "game" || selectedCategory === "All") {
      sections.push(
        <>
          <SearchGameComponent
            heading={"Games"}
            styles={styles}
            eventsResultEmpty={gameResultEmpty}
            eventsResult={gameResult}
            showLoader={showLoader}
          />
        </>
      );
    }
    return sections;
  };
  return (
    <>
      <View style={{ flex: 1 }}>
        <ScreenBGGradientView />
        {deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM ? (
          <SearchScreentNavigationHeader
            btnSearchTapped={(txt) => {
              if (txt.length > 0) {
                setSearchEvent(txt);
                callSearchAPI(txt);
              }
            }}
          />
        ) : (
          <Header
            btnSearchTapped={(txt) => {
              if (txt.length > 0) {
                setSearchEvent(txt);
                callSearchAPI(txt);
              }
            }}
            btnWalletTapped={() => {}}
            btnStartTutorialTapped={() => {}}
            btnMessageTapped={() => {}}
            btnNotificationTapped={() => {}}
            btnProfileTapped={() => {}}
          />
        )}

        <View style={[styles.container, { flex: 1 }]}>
          <ScrollView
            style={{ flex: 1 }}
            showsVerticalScrollIndicator={false}
            showsHorizontalScrollIndicator={false}
          >
            {/* Search Result for “A” */}
            {showLoader ? (
              <SearchResultSkeleton />
            ) : (
              <SearchResult
                searchEvent={searchEvent}
                setSelectedCategory={setSelectedCategory}
              />
            )}

            {renderSection()}

            {/* Results  */}
            <ScrollView
              showsHorizontalScrollIndicator={false}
              showsVerticalScrollIndicator={false}
            >
              {renderEventSection()}
            </ScrollView>
          </ScrollView>
        </View>

        {/* Show Loader */}
        {/* {<ShowLoader showIndicater={showLoader} />} */}
      </View>
    </>
  );

  function getItemCount() {
    if (deviceSize === "extralarge") {
      return 5;
    } else if (deviceSize === "large") {
      return 4;
    } else if (deviceSize === "medium") {
      return 3;
    } else {
      return 2;
    }
  }

  function ShowBackButton(props) {
    const { onPress } = props;
    return (
      <TouchableOpacity
        style={{
          // justifyContent: ''
          width: 40,
          height: 40,
          backgroundColor: AppColors.appBlackColor_1e1e1e,
          borderRadius: 10,
          flexDirection: "row",
          alignItems: "center",
          paddingHorizontal: 12,
          justifyContent: "space-between",
        }}
        onPress={() => {
          onPress();
        }}
      >
        <Image
          source={AppImages.icArrowRight}
          style={{
            height: 16,
            width: 16,
            resizeMode: "contain",
            transform: [{ rotate: "180deg" }],
          }}
        />
      </TouchableOpacity>
    );
  }

  function SortByView(props) {
    const { onPress } = props;
    return (
      <TouchableOpacity
        style={styles.sortByStyle}
        onPress={() => {
          onPress();
        }}
      >
        <Text
          style={[AppFontStyle.BOLD_ANYBODY_12, { color: AppColors.white }]}
        >
          Sort By
        </Text>
        <Image
          source={AppImages.icArrowDown}
          style={{
            height: 16,
            width: 16,
            resizeMode: "contain",
          }}
        />
      </TouchableOpacity>
    );
  }

  async function getLoginUserData() {
    const data = await getLoginData();
    if (data != null) {
      setUserData(data);
      userProfileAPI(data.AccessToken);
      setAccessToken(data.AccessToken);
    }
  }

  // searchEventAPI API
  function searchEventAPI(props) {
    setShowLoader(true);

    const { txtSearch = {}, success = () => {} } = props;
    let url =
      base_url +
      endpoints.events.searchEvent +
      `?query=${encodeURIComponent(txtSearch)}`;

    return fetch(url, {
      mode: "cors",
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then(async function (data) {
        const status = data.status;

        const responce = await data.json();
        const statusCode = data.status;

        setShowLoader(false);
        if (status === 200) {
          success(responce.results);
          // if (responce.statusCode === 200) {
        } else if (status == 400) {
          toast.error("Bad Request");
        } else if (status > 400 && 420 < status) {
          toast.error("Unauthorized");
        } else if (status >= 500) {
          toast.error("Internal Server Error");
        }
      })
      .catch((error) => {
        setShowLoader(false);
        console.log("Authorization failed: " + error.message);
        toast.error(error.message);
      });
  }
};

export default SearchEventWebScreen;

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      backgroundColor: "transparent",
      paddingHorizontal: "3.5%",
      paddingTop: "2.5%",
    },
    searchTextStyle: {
      backgroundColor: AppColors.appGrayColor_1C1C1C,
      width: "50%",
      height: 35,
      alignItems: "center",
      borderWidth: 0,
    },
    listBgViewStyle: {
      gap: 8,
      marginBottom: 18,
    },
    attendeesBgViewStyle: {
      backgroundColor: AppColors.appViolentColor_6D08C3,
      borderRadius: 7,
      alignSelf: "flex-start",
    },
    sortByStyle: {
      // justifyContent: ''
      width: 130,
      height: 35,
      backgroundColor: AppColors.appBlackColor_1e1e1e,
      borderRadius: 10,
      flexDirection: "row",
      alignItems: "center",
      paddingHorizontal: 12,
      justifyContent: "space-between",
    },
    columnWrapperStyle: {
      gap: 30,
    },
  },
  {
    [DEVICE_SIZES.MD]: {
      container: {
        flex: 1,
        backgroundColor: "transparent",
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      searchTextStyle: {
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        width: "50%",
        height: 35,
        alignItems: "center",
        borderWidth: 0,
      },
      listBgViewStyle: {
        gap: 8,
      },
      attendeesBgViewStyle: {
        backgroundColor: AppColors.appViolentColor_6D08C3,
        borderRadius: 7,
        alignSelf: "flex-start",
      },
      sortByStyle: {
        // justifyContent: ''
        width: 130,
        height: 35,
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        borderRadius: 10,
        flexDirection: "row",
        alignItems: "center",
        paddingHorizontal: 12,
        justifyContent: "space-between",
      },
      columnWrapperStyle: {
        gap: 20,
      },
    },
    [DEVICE_SIZES.LG]: {
      container: {
        flex: 1,
        backgroundColor: "transparent",
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      searchTextStyle: {
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        width: "50%",
        height: 35,
        alignItems: "center",
        borderWidth: 0,
      },
      listBgViewStyle: {
        gap: 8,
      },
      attendeesBgViewStyle: {
        backgroundColor: AppColors.appViolentColor_6D08C3,
        borderRadius: 7,
        alignSelf: "flex-start",
      },
      sortByStyle: {
        width: 130,
        height: 36,
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        borderRadius: 10,
        flexDirection: "row",
        alignItems: "center",
        paddingHorizontal: 12,
        justifyContent: "space-between",
      },
      columnWrapperStyle: {
        gap: 25,
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        flex: 1,
        backgroundColor: "transparent",
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      searchTextStyle: {
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        width: "40%",
        height: 35,
        alignItems: "center",
        borderWidth: 0,
      },
      listBgViewStyle: {
        gap: 8,
      },
      attendeesBgViewStyle: {
        backgroundColor: AppColors.appViolentColor_6D08C3,
        borderRadius: 7,
        alignSelf: "flex-start",
      },
      sortByStyle: {
        // justifyContent: ''
        width: 100,
        height: 35,
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        borderRadius: 10,
        flexDirection: "row",
        alignItems: "center",
        paddingHorizontal: 12,
        justifyContent: "space-between",
      },
      columnWrapperStyle: {
        gap: 20,
      },
    },
    [DEVICE_SIZES.XS]: {
      container: {
        flex: 1,
        backgroundColor: "transparent",
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      searchTextStyle: {
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        width: "34%",
        height: 35,
        alignItems: "center",
        borderWidth: 0,
      },
      listBgViewStyle: {
        gap: 8,
      },
      attendeesBgViewStyle: {
        backgroundColor: AppColors.appViolentColor_6D08C3,
        borderRadius: 7,
        alignSelf: "flex-start",
      },
      sortByStyle: {
        // justifyContent: ''
        width: 100,
        height: 35,
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        borderRadius: 10,
        flexDirection: "row",
        alignItems: "center",
        paddingHorizontal: 12,
        justifyContent: "space-between",
      },
      columnWrapperStyle: {
        gap: 16,
      },
    },
  }
);
